import Image from "@/components/Image";
import { areas } from "@/constants/areas";
import { Col, Row } from "antd";
import classNames from "classnames";
import styles from "./index.module.less";

export default function AreaSelect({ value, onChange }) {
  return (
    <Row gutter={[12, 12]}>
      {areas.map((area) => {
        return (
          <Col
            span={6}
            key={area.code}
            onClick={() => {
              if (value?.includes(area.id)) {
                onChange(value.filter((v) => v !== area.id));
              } else {
                onChange([...(value || []), area.id]);
              }
            }}
          >
            <div
              className={classNames(styles.areaCard, {
                [styles.selected]: value?.includes(area.id),
              })}
            >
              <Image src={area.icon} width={20} height={20} alt="" />
              {area.name}
            </div>
          </Col>
        );
      })}
    </Row>
  );
}
